import { useState, useEffect } from "react";

function count(w) {
  if (w < 580) return 1;
  if (w < 900) return 2;
  if (w < 1280) return 3;
  return 4;
}

export default function useSlideCount() {
  const [slides, setSlides] = useState(() => count(window.innerWidth));

  useEffect(() => {
    const update = () => setSlides(count(window.innerWidth));
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return slides;
}
